import { render, staticRenderFns } from "./CardMealActionDislike.vue?vue&type=template&id=6ec98ffe&scoped=true"
import script from "./CardMealActionDislike.vue?vue&type=script&lang=js"
export * from "./CardMealActionDislike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec98ffe",
  null
  
)

export default component.exports